// extracted by mini-css-extract-plugin
export var actions = "_hg-g";
export var benefitCard = "_hg-b";
export var benefitIcon = "_hg-d";
export var benefitLabel = "_hg-f";
export var benefits = "_hg-a";
export var benefitsSection = "_hg-8";
export var bodyText = "_hg-7";
export var closeButton = "_hg-2";
export var content = "_hg-3";
export var eyebrow = "_hg-4";
export var heading = "_hg-5";
export var image = "_hg-i";
export var imagePanel = "_hg-h";
export var modal = "_hg-0";
export var offerCard = "_hg-c";
export var offerIcon = "_hg-e";
export var sectionLabel = "_hg-9";
export var shell = "_hg-1";
export var title = "_hg-6";